var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-vdo"},[_c('div',{staticClass:"upload-btn"},[_vm._v(" Upload Video "),_c('input',{staticClass:"input_file",attrs:{"type":"file"},on:{"change":_vm.uploadItem}})])])}
var staticRenderFns = []

export { render, staticRenderFns }